import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { deletePolicyList } from "./policyService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import moment from "moment";
import { getPolicyList } from "./policyService";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);

const Policydetail = () => {
  const [policyList, setpolicyList] = useState([]);
  const { GUID } = useParams();
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const history = useHistory();
  const [deletePolicyId, setDeletePolicyId] = useState(0);
  const [deleteContent, setSeleteContent] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [policyUpdatePermission, setPolicyUpdatePermission] = useState(false);
  const [policyDeletePermission, setPolicyDeletePermission] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");

  useEffect(() => {
    getPolicyListData();
    permissionPolicyBased();
  }, []);

  async function deletePolicy(id) {
    if (id) {
      setIsloading(true);
      const body = {
        Id: id,
      };
      try {
        let policyList = await deletePolicyList(body);
        if (policyList) {
          document.querySelector("#delete-policy .btn-close")?.click();
          GetMasterSystemAlertList("Policy_Deleted", 0);
          getPolicyListData();
          setTimeout(() => {
            history.push("/Policylist");
          }, 1000);
          setIsloading(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const permissionPolicyBased = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Policy.Update") {
        setPolicyUpdatePermission(true);
      } else if (UserPermission.PermissionName == "Policy.Delete") {
        setPolicyDeletePermission(true);
      }
    });
  };

  async function getPolicyListData() {
    setIsloading(true);
    const param = {
      OrgId: userDetails?.OrgId,
      CategoryId: 0,
      IsPublished: 0,
      GUID: GUID,
      pagenumber: 1,
      pagesize: 100,
    };
    try {
      let projectDetailData = await getPolicyList(param);
      setpolicyList(projectDetailData?.Data?.policyList);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  }

  const determineDocType = (DocData) => {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp)$/i;
    const pdfExtension = /\.pdf$/i;
    if (imageExtensions.test(DocData)) {
      return "image";
    } else if (pdfExtension.test(DocData)) {
      return "pdf";
    } else {
      return "Doc";
    }
  };

  return (
    <div className="policy-module">
      <div className="container-fluid position-relation">
        {policyList && (
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">{policyList[0]?.PolicyName}</h2>
              <div className="media-meta">
                <span>
                  Category :<b> {policyList[0]?.PolicyCategoryName}</b>
                </span>
                <span className="separator">|</span>
                <span className="meta-item d-flex align-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="11"
                    fill="currentColor"
                    className="bi bi-calendar me-1"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"></path>
                  </svg>
                  On {moment(policyList[0]?.ModifiedDate).format("MMM DD YYYY")}
                </span>
              </div>
            </div>
            <div className="form-head mb-4 d-flex flex-wrap align-items-center">
              {policyUpdatePermission && (
                <button className="edit-policy">
                  <Link to={`/EditPolicy/${GUID}`} className="text-white">
                    <i aria-hidden="true" className="fa fa-edit me-2"></i>Edit
                  </Link>
                </button>
              )}

              {policyDeletePermission && (
                <button className="delete-policy">
                  <a
                    onClick={() => {
                      setDeletePolicyId(policyList?.Id);
                      GetMasterSystemAlertList("Policy_Delete");
                    }}
                    className="text-white"
                    title="Delete"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-policy"
                  >
                    <i aria-hidden="true" className="fa fa-trash me-2"></i>
                    Delete
                  </a>
                </button>
              )}
              <Link to="/Policylist" className="add-btncss-dark" style={{ marginLeft: "9px" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-left-short me-2"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                  ></path>
                </svg>
                Back
              </Link>
            </div>
          </div>
        )}
        <div className="card mt-4">
          {policyList?.map((el) => (
            <div className="policysection">
              <div className="main-policy-section">
                <h3>{el?.PolicyName}</h3>
                {/* <p role="presentation">{el?.ShortDesc}</p> */}
                <p role="presentation"
                              dangerouslySetInnerHTML={{
                                __html: el?.ShortDesc,
                              }}></p>
              </div>
              <div className="bottom-policy-section">
                <div className="left-detail">
                  {el?.policyDetailsList?.map((item) => (
                    <div className="sub-section">
                      <h5>{item?.ParagraphHeader}</h5>
                     
                       <p 
                              dangerouslySetInnerHTML={{
                                __html: item?.ParagraphDescription,
                              }}></p>
                    </div>
                  ))}
                </div>
                {el?.policyDocumentlist.length > 0 && (
                  <div className="right-documents">
                    <p className="title">Policy Documents</p>
                    <ul>
                      {el?.policyDocumentlist.map((doc) => {
                        let DocType = determineDocType(doc?.PolicyDocumentPath);
                        return (
                          <li>
                            {DocType == "image" && (
                              <img
                                src={doc?.PolicyDocumentPath}
                                className="w-100"
                              />
                            )}
                            {DocType == "Doc" && (
                              <div className="inner">
                                <img
                                  src="/images/tickets/doc.jpg"
                                  className="w-100"
                                  alt="Doc"
                                />
                              </div>
                            )}
                            {DocType == "pdf" && (
                              <div className="inner">
                                <img
                                  src="/images/tickets/pdf.png"
                                  className="w-100"
                                  alt="Doc"
                                />
                              </div>
                            )}
                            <div className="inner-docli">
                              <a>
                                <strong title={doc.PolicyDocumentName}>
                                  {doc?.PolicyDocumentName?.length > 15
                                    ? doc.PolicyDocumentName.slice(0, 15) +
                                    "..."
                                    : doc?.PolicyDocumentName}
                                </strong>
                              </a>
                              <p>
                                {moment(doc?.ModifiedDate).format(
                                  "MMM DD YYYY"
                                )}
                              </p>
                            </div>
                            <a
                              href={doc?.PolicyDocumentPath}
                              target="blank"
                              download
                              className="p-0"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-download"
                                viewBox="0 0 16 16"
                              >
                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                              </svg>
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {policyList?.map((policy) => {
        return (
          <div className="modal fade" id="delete-policy">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img
                    src="/images/popup-icons/delete.png"
                    style={{ width: "20%" }}
                  />
                  <strong className="modal-title">Are you sure?</strong>
                  <p>{deleteContent}</p>
                </div>
                <div className="modal-footer m-auto">
                  <button
                    type="button"
                    className="btn btn-danger light"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="deletebtn-click"
                    onClick={() => deletePolicy(policy?.Id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}{" "}
      {Isloading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default Policydetail;
